<div class="main">
  <spb-header class="no-print"/>
  <router-outlet/>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
    class="no-print"
    copyrightYears="2020"
  />
</div>